var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21338 14.3105C2.68652 14.3105 2.51514 13.917 2.81982 13.5361C3.07373 13.2061 3.68311 12.5205 4.06396 11.8857C4.12744 11.7588 4.0957 11.6636 3.9624 11.5938C1.84863 10.4448 0.63623 8.59131 0.63623 6.54102C0.63623 3.2085 3.95605 0.523438 8.10107 0.523438C12.2461 0.523438 15.5659 3.2085 15.5659 6.54102C15.5659 10.1211 12.1572 12.5586 7.56787 12.5649C7.51074 12.5649 7.44092 12.5586 7.3584 12.5522C7.25049 12.5522 7.14258 12.584 7.01562 12.6729C5.82227 13.5171 3.99414 14.3105 3.21338 14.3105Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b2bbbc0c1529bafb23dbd00309208216.svg";
export { ForwardRef as ReactComponent };